import { aiFirstCreateEntryPoint } from '@jira/spa-apps__ai-first-create/src/aiFirstCreateEntryPoint.entrypoint.tsx';
import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createEntry } from '@jira/platform__routing-route-entry';
import { aiFirstCreateRoute } from '@jira/router-routes__ai-first-create-routes/src/aiFirstCreateRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const AIFCEmbedPageEntryPoint = createChromelessEntryPoint({
	main: aiFirstCreateEntryPoint,
});

export const aiFirstCreateRouteEntry: Route = createEntry(
	// baseRoute refers to the static route definition above
	aiFirstCreateRoute,
	() => ({
		group: 'aifc',
		ufoName: 'jira-ai-first-create.embed-view',
		layout: chromelessLayout,
		entryPoint: () => AIFCEmbedPageEntryPoint,
		resources: [aiEntitlementResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
